import { MarketItem, Specs } from "@/lib/user-specs-market-item/user-specs";
import { UserTypes } from "@/types/types";

export interface PrivateUserProfileInfo {
  sub: string;
  photo_url: string;
  complete_name: string;
  active_listings: number;
  phone_number: string;
  has_whatsapp_active: boolean;
  nationality: string;
  user_type: UserTypes;
  socials: {
    whatsapp?: string;
  };
}

export type AgentPortfolioSection = "properties" | "articles";

// export interface AgentPublicProfileInfo {
//   sub: string;
//   photo_url: string;
//   complete_name: string;
//   active_listings: number;
//   phone_number: string;
//   user_description: string;
//   has_whatsapp_active: boolean;
//   nationality: string;
//   agency_name: string;
//   agency_photo_url: string;
//   agency_website_url: string;
//   agency_id: string;
//   user_type: UserTypes;
//   spoken_languages: string[];
//   years_experience: number;
//   response_time: number;
//   specs: Specs;
//   markets?: MarketItem[];
//   socials: {
//     whatsapp?: string;
//     linkedin?: string;
//     instagram?: string;
//     facebook?: string;
//     tiktok?: string;
//     x?: string;
//     youtube?: string;
//   };
// }

export type SocialPlatform =
  | "linkedin"
  | "instagram"
  | "facebook"
  | "tiktok"
  | "x"
  | "youtube";

export const SOCIAL_CONFIG: Record<
  SocialPlatform,
  { label: string; icon: string }
> = {
  linkedin: {
    label: "Linked In",
    icon: "/socials/linkedin.svg",
  },
  instagram: {
    label: "Instagram",
    icon: "/socials/instagram.svg",
  },
  facebook: {
    label: "Facebook",
    icon: "/socials/facebook.svg",
  },
  tiktok: {
    label: "Tik Tok",
    icon: "/socials/tiktok.svg",
  },
  x: {
    label: "X",
    icon: "/socials/x.svg",
  },
  youtube: {
    label: "Youtube",
    icon: "/socials/youtube.svg",
  },
};

export type PublicProfileServiceArea = {
  slug: string;
  name: string;
  type?: string;
  listings_count: number;
};

export type PublicProfileListingFocus = {
  residential: {
    total: number;
    for_sale: number;
    for_rent: number;
  };
  commercial: {
    total: number;
    for_sale: number;
    for_rent: number;
  };
};

export interface PublicProfileResponse {
  sub: string;
  user_type: UserTypes;

  complete_name: string;
  professional_title?: string;
  photo_url: string;
  user_description: string;
  featured_quote?: string;

  nationality?: string;
  spoken_languages: string[];

  contact: {
    phone_number: string;
    email_available: boolean;
    has_whatsapp_active: boolean;
  };

  socials: Partial<Record<SocialPlatform, string>>;

  agency?: {
    id: string;
    name: string;
    photo_url: string;
    website_url?: string;
  };

  location?: {
    slug?: string;
    name?: string;
    country_code?: string;
  };

  statistics: {
    active_listings: number;
    max_active_listings?: number;
    years_experience?: number | null;
    response_time_minutes?: number | null;
    articles_count?: number;
  };

  listing_focus?: PublicProfileListingFocus;

  specialties: string[];
  services: string[];
  service_areas: PublicProfileServiceArea[];

  specs: Specs;
  markets?: MarketItem[];
}

export const MOCK_PUBLIC_PROFILE: PublicProfileResponse = {
  sub: "mock-agent-andrei-lamba",
  user_type: UserTypes.AGENT,

  complete_name: "Andrei Lamba",
  professional_title: "Luxury Property Advisor",
  photo_url:
    "https://d3m180cldafi3j.cloudfront.net/processed/98/e1/98e1aed0-609e-411a-a535-3357e3c08172/lg.jpg",
  featured_quote: "The right property is not merely found. It is understood.",
  user_description:
    "I advise private clients, families, and investors seeking exceptional homes across Bucharest. My approach combines considered market knowledge, discretion, and an enduring commitment to each client’s ambitions. I advise private clients, families, and investors seeking exceptional homes across Bucharest. My approach combines considered market knowledge, discretion, and an enduring commitment to each client’s ambitions. I advise private clients, families, and investors seeking exceptional homes across Bucharest. My approach combines considered market knowledge, discretion, and an enduring commitment to each client’s ambitions. I advise private clients, families, and investors seeking exceptional homes across Bucharest. My approach combines considered market knowledge, discretion, and an enduring commitment to each client’s ambitions.",

  nationality: "RO",
  spoken_languages: ["ro", "en", "fr", "de"],

  contact: {
    phone_number: "+40 748 114 749",
    email_available: true,
    has_whatsapp_active: true,
  },

  socials: {
    linkedin: "https://linkedin.com",
    instagram: "https://instagram.com",
    facebook: "https://facebook.com",
    youtube: "https://youtube.com",
  },

  agency: {
    id: "doomum-real-estate",
    name: "Doomum Real Estate",
    photo_url: "/placeholder-agency.png",
    website_url: "https://doomum.com",
  },

  location: {
    slug: "bucharest",
    name: "Bucharest",
    country_code: "RO",
  },

  statistics: {
    active_listings: 32,
    years_experience: 9,
    response_time_minutes: 22,
    articles_count: 8,
  },

  listing_focus: {
    residential: {
      total: 27,
      for_sale: 21,
      for_rent: 6,
    },
    commercial: {
      total: 5,
      for_sale: 3,
      for_rent: 2,
    },
  },

  specialties: [
    "Luxury residential",
    "Investment properties",
    "New developments",
    "Private sales",
    "Relocation",
  ],

  services: [
    "Private acquisition advisory",
    "Property valuation",
    "Negotiation and transaction management",
    "Investment portfolio advisory",
    "Relocation support",
  ],

  service_areas: [
    {
      slug: "primaverii",
      name: "Primăverii",
      type: "neighborhood",
      listings_count: 11,
    },
    {
      slug: "herastrau",
      name: "Herăstrău",
      type: "neighborhood",
      listings_count: 8,
    },
    {
      slug: "aviatorilor",
      name: "Aviatorilor",
      type: "neighborhood",
      listings_count: 6,
    },
    {
      slug: "floreasca",
      name: "Floreasca",
      type: "neighborhood",
      listings_count: 5,
    },
    {
      slug: "dorobanti",
      name: "Dorobanți",
      type: "neighborhood",
      listings_count: 2,
    },
  ],

  specs: {} as Specs,
  markets: [],
};
